import { initializeFitmentCheckers, initializeSearchBars, initializeVehicleSelectors, initializeGlobalModal, initializeModalButtons } from "./gbrakes-public/app.js";

import "./gbrakes-public.css"

/**
 * Finds all placeholder elements with the specified class and mounts a React app in each one.
 * This allows for multiple independent instances of the component on the same page.
 */
document.addEventListener('DOMContentLoaded', () => {
  initializeVehicleSelectors();
  initializeFitmentCheckers();
  initializeSearchBars();
  initializeGlobalModal();
  initializeModalButtons();
});

